import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import { faWrench } from '@fortawesome/free-solid-svg-icons';
import { ControllerForViewBase } from '../framework/controller-for-view-base';
import { PageContainerService } from '../../services';
import { ProjectDto, ClientDto, AssetDto } from "../../data/CommandServiceDtos.generated";
import {
  ReadinessSummaryDto,
  GetTaskPriorityStatusCommandRequest,
  GetTaskPriorityStatusCommandResponse
} from "../../data/CommandServiceDtos.generated";

@Component({
  selector: 'project-summary-readiness',
  templateUrl: './project-summary-readiness.component.html',
  styleUrls: ['./project-summary-readiness.component.scss']
})

export class ProjectSummaryReadinessComponent implements OnInit {
  @Input() readinessSummary: ReadinessSummaryDto;
  @Input() proPakProjectId: number;
  readinessOverallComplete: number;
  readinessPath: string;
  currentUrl: string;
  faFileDownload = faFileDownload;
  faWorkPackIcon = faWrench;
  proPakProjectUrl: string;
  passThroughAuthKey: string;
  userName: string;

  constructor(private pcs: PageContainerService, private http: HttpClient, private route: Router) {
    this.userName = pcs.clientSessionService.userName;
  }

  ngOnInit() {
    this.readinessOverallComplete = this.readinessSummary.PercentComplete;
    this.readinessPath = this.readinessSummary.ReadinessFileLocation;
    this.proPakProjectUrl = this.readinessSummary.ProPakProjectUrl;
    this.passThroughAuthKey = this.readinessSummary.PassThroughAuthKey;
    this.currentUrl = this.route.url;
  }

  downloadFile() {
    if (this.readinessPath === null) {
      this.pcs.notificationService.warning("No Spreadsheet for this Project", "", { timeOut: 3000 });
      return;
    }

    //We want to open this in a new window/tab so we don't load over the application.
    window.open(this.readinessPath, '_blank');
  }

  launchProPak() {
    window.open(`${this.proPakProjectUrl}#${this.userName},${this.passThroughAuthKey},${this.proPakProjectId}`, "_blank");
  }
}



// WEBPACK FOOTER //
// ./src/app/components/project-summary-readiness/project-summary-readiness.component.ts